import { observer } from 'mobx-react-lite';
import { UnitQueueRowData } from '../../../socket/stream-types';
import { BaseQueueCell } from '../../../queues/components/base-queue-cell';
import { Flex, Icon } from '@cad-arc';
import { agencyTypeIconNames } from '../../../common/helpers/agency-type';
import { AgencyTypeGlobal } from '../../../common/global-attributes';

export const UnitClassIconCell = observer(function UnitClassIconCell({
    data,
}: {
    data: UnitQueueRowData;
}): React.ReactElement {
    const iconName = agencyTypeIconNames[data.agencyTypeGlobalAttrId as AgencyTypeGlobal];
    return (
        <BaseQueueCell>
            {iconName && (
                <Flex justify="center">
                    <Icon icon={iconName} color="icon.default" className="queue-cell-icon" />
                </Flex>
            )}
        </BaseQueueCell>
    );
});
